import BasePointManager from "../../../../../src/managers/BasePointManager";
import { Coord, RedPointRadianInfo } from "../../../../../src/types/Interface";
import { eventBus, EnumEventBus } from "./EventBus";
import generatePoints from "../../../../../src/utils/generator/generatePoints";
import { normalizeRadian } from "../../../../../src/utils/math/normalizeRadian";
import { CIRCLE_RADIUS, INITIAL_RADIANS } from "../types/Config";
import { TangentType } from "../types/Enum";


export default class PointManager extends BasePointManager {
	private tangentType: TangentType = TangentType.type1;

	constructor(cCoord: Coord) {
		super(cCoord, CIRCLE_RADIUS, INITIAL_RADIANS);
		this.setCoord();
		this.draw();

		eventBus.on(EnumEventBus.moveCircumPoint, (v: number) => this.handleMoveCircumPointSlider(v));
		eventBus.on(EnumEventBus.setTangentType, (v: TangentType) => this.tangentType = v);
	}

	handleMoveCircumPointSlider(v: number) {
		const points = this.getRedPoints();
		const refRadians = this.getRefRadians();
		const radian = refRadians[0] + Math.PI / 90 * v;
		const pointInfo: RedPointRadianInfo = { pTag: points[0].tag, radian }
		this.setRadian([pointInfo], true);
	}

	getTangentCoords(): Coord[] {
		const pointARadian = this.getRadians()[0];
		const pointA = this.getRedPointsCoord()[0];
		const _radian = pointARadian + Math.PI / 2;
		const radians = [normalizeRadian(_radian), normalizeRadian(_radian + Math.PI)];
		const tangentCoords = generatePoints(pointA, radians, 150);
		return this.tangentType == TangentType.type1 ? tangentCoords : [pointA, tangentCoords[1]];
	}
}